<template>
  <div class="icon-wrapper">
    <awesome-icon
      :color="fillColor"
      :height="size"
      :name="type"
      :spin="spin"
      :width="size"
    />
  </div>
</template>

<script>



export default {
  name: 'Icon',

  props: {
    link: {
      required: false,
      type: Boolean
    },
    fill: {
      default: 'black',
      required: false,
      type: String
    },
    size: {
      default: 20,
      type: Number
    },
    spin: {
      required: false,
      type: Boolean
    },
    type: {
      required: true,
      type: String
    }
  },

  computed: {
    fillColor() {
      if (this.link) {
        return "rgb(19, 118, 157)"
      } else {
        return this.fill
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.icon-wrapper {
  align-self: center;
  display: inline-flex;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue